<!-- main app container -->
<div class="card m-3">
    <h5 class="card-header" class="text-secondary">Añadir Usuario</h5>
    <div class="card-body">
        <form [formGroup]="registerForm" class="text-secondary">
            <div class="form-group">
                <label for="exampleInputZone">Rut Usuario</label>
                <input type="text" formControlName="rUsuario" class="form-control">
            </div>
            <div class="form-group">
                <label for="exampleInputZone">Nombre Usuario</label>
                <input type="text" formControlName="nUsuario" class="form-control">
            </div>
            <div class="form-group">
                <label for="exampleInputZone">Contraseña</label>
                <input type="text" formControlName="cUsuario" class="form-control">
            </div>
            <div class="form-group">
                <label for="exampleInputZone">Estado</label><br>
                <select class="form-control" formControlName="eUsuario">
                    <option value="true">Habilitado</option>
                    <option value="false">Deshabilitado</option>
                </select>
            </div> 
        </form>
    </div>
    <form>
        <div class="text-center">
            <button class="btn btn-primary mr-1" type="submit" (click)="agregarUsuarios()">GUARDAR</button>
            <button class="btn btn-secondary" (click)="cerrarModal()">CANCELAR</button>
        </div>
    </form>
</div>